'use client';

import Script from 'next/script';

export default function FullStoryScript() {
  return (
    <Script
      id="rb2b-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
!function(key) {if (window.reb2b) return;window.reb2b = {loaded: true};var s = document.createElement("script");s.async = true;s.src = "https://ddwl4m2hdecbv.cloudfront.net/b/" + key + "/" + key + ".js.gz";document.getElementsByTagName("script")[0].parentNode.insertBefore(s, document.getElementsByTagName("script")[0]);}("GOYPYHQV1JOX");
        `,
      }}
    />
  );
}
